const seoConfig = {
  default: {
    title: "Parfumhaus Hangelar – Parfümerie & Kosmetik in Sankt Augustin",
    description:
      "Parfumhaus Hangelar in Sankt Augustin: exklusive Düfte, Kosmetikbehandlungen und Make-up mit persönlicher Beratung."
  },
  pages: {
    home: {
      title: "Parfumhaus Hangelar – Parfümerie & Kosmetik in Sankt Augustin",
      description:
        "Entdecken Sie Düfte, Kosmetikbehandlungen und Make-up beim Parfumhaus Hangelar in Sankt Augustin mit individueller Beratung."
    },
    impressum: {
      title: "Impressum – Parfumhaus Hangelar Sankt Augustin",
      description:
        "Kontakt, Adresse und rechtliche Informationen zum Parfumhaus Hangelar in Sankt Augustin."
    }
  }
};

export default seoConfig;